import { AuthApi } from "@/api/auth";
import { SetAdminPasswordRequest } from "@/api/auth/types/set-admin-password.types";
import { LocalStorageService } from "@/utils";
import { useMutation } from "@tanstack/react-query";
import { useNotify } from "react-admin";
import { useNavigate } from "react-router-dom";
import { useLoginPageStore } from "../context";

export const useSetAdminPassword = () => {
  const { adminData } = useLoginPageStore();
  const notify = useNotify();
  const navigate = useNavigate();

  const { mutate: setAdminPassword, isPending: isSetAdminPasswordLoading } =
    useMutation({
      mutationFn: (body: SetAdminPasswordRequest) =>
        AuthApi.setAdminPassword(body),
      onSuccess: () => {
        if (adminData) {
          LocalStorageService.setRefreshToken(adminData.tokens.refreshToken);
          LocalStorageService.setAccessToken(adminData.tokens.accessToken);
          navigate("/");
        }
      },
      onError: (error) => {
        notify(error, { type: "error" });
      },
    });

  return { setAdminPassword, isSetAdminPasswordLoading };
};
